import merge from 'lodash/merge';
import SurveySearchService from './services/survey-search.service';
import ServiceProvider from './services/service.provider';
import DataProvider from './services/data.provider';
import AppCarousel from './views/AppCarousel.svelte';
class SurveyCarouselApp {
    constructor(options) {
        this.options = options;
    }
    mount() {
        try {
            this.prepareOptions();
            this.dataProvider = new DataProvider(this.options);
            const searchService = new SurveySearchService(this.dataProvider);
            this.serviceProvider = new ServiceProvider(searchService);
            this.createInstance();
        }
        catch (e) {
            console.log(e);
        }
    }
    createInstance() {
        new AppCarousel({
            target: this.targetElement,
            props: {
                serviceProvider: this.serviceProvider,
                dataProvider: this.dataProvider
            }
        });
    }
    get targetElement() {
        const { carouselEl } = this.options;
        const element = document.querySelector(carouselEl);
        if (null === element) {
            throw new Error("The container for displaying Surveys does not exist");
        }
        return element;
    }
    // OPTIONS
    prepareOptions() {
        this.options = merge({}, {
            carouselEl: null,
            portalUrl: null,
            showSiteUrl: null,
            published: null,
            heading: null,
        }, this.options);
    }
}
(function () {
    const carousel = document.getElementById('carousel-survey-module');
    if (carousel) {
        const portalUrl = carousel.getAttribute("data-portal-url") || "";
        const showSiteUrl = carousel.getAttribute("data-show-site-url") || "false";
        const published = carousel.getAttribute("data-published") || null;
        const heading = carousel.getAttribute("data-heading") || "";
        const surveyCarouselApp = new SurveyCarouselApp({
            carouselEl: "#carousel-survey-module",
            portalUrl,
            showSiteUrl,
            published,
            heading,
        });
        surveyCarouselApp.mount();
    }
})();
